// extracted by mini-css-extract-plugin
export default {"container":"client_container__OryoT","first":"client_first__mMTtt","btn":"client_btn__NV5wE","all":"client_all__csq8i","client":"client_client__qBeas"};